import { Remove } from '@mui/icons-material';
import { Button, Divider, Grid, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { CreateBookingSlot, CreateProduct } from '@thro-types/leihbar';

import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export const BookingSlotsPicker = () => {
  const { t } = useTranslation();
  const { values, errors, touched, setFieldValue, handleBlur } = useFormikContext<CreateProduct>();

  const handleDateChange = (index: number, value: Date | null, type: 'START' | 'END' | 'ADD') => {
    let updatedBookingSlots: CreateBookingSlot[] = [...values.possibleBookingSlots];
    if (!value) {
      return;
    }
    if (type === 'START') {
      updatedBookingSlots[index].start = value;
    } else if (type === 'END') {
      updatedBookingSlots[index].end = value;
    } else if (type === 'ADD') {
      updatedBookingSlots.push({ start: value, end: value });
    }

    setFieldValue('possibleBookingSlots', updatedBookingSlots);
  };
  return (
    <Grid container spacing={2}>
      {values.possibleBookingSlots.map((_bookingSlot, index) => {
        return (
          <Grid item xs={12} container key={index} justifyContent={'space-between'} gap={'4px'}>
            <Grid container item xs={8} xl={5} className="bookingslots-picker">
              <Grid item xs={3}>
                <Typography>
                  {t(translations.pages.leihbar.product.create.bookingSlot.start())}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <DatePicker
                  renderInput={props => (
                    <TextField
                      {...props}
                      id="possibleBookingSlots.start"
                      name="possibleBookingSlots.start"
                      variant="outlined"
                      error={touched.possibleBookingSlots && Boolean(errors.possibleBookingSlots)}
                      helperText={
                        touched.possibleBookingSlots && <>{errors.possibleBookingSlots}</>
                      }
                      onBlur={handleBlur}
                      fullWidth
                      size="small"
                    />
                  )}
                  value={values.possibleBookingSlots[index].start}
                  onChange={value => {
                    handleDateChange(index, value, 'START');
                  }}
                  mask="__.__.____"
                  minDate={new Date()}
                  inputFormat="dd.MM.yyyy"
                />
              </Grid>
            </Grid>
            <Grid container item xs={8} xl={5} className="bookingslots-picker">
              <Grid item xs={3}>
                <Typography>
                  {t(translations.pages.leihbar.product.create.bookingSlot.end())}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <DatePicker
                  renderInput={props => (
                    <TextField
                      {...props}
                      id="possibleBookingSlots.end"
                      name="possibleBookingSlots.end"
                      variant="outlined"
                      error={touched.possibleBookingSlots && Boolean(errors.possibleBookingSlots)}
                      helperText={
                        touched.possibleBookingSlots && <>{errors.possibleBookingSlots}</>
                      }
                      onBlur={handleBlur}
                      fullWidth
                      size="small"
                    />
                  )}
                  value={values.possibleBookingSlots[index].end}
                  onChange={value => {
                    handleDateChange(index, value, 'END');
                  }}
                  mask="__.__.____"
                  minDate={new Date()}
                  inputFormat="dd.MM.yyyy"
                />
              </Grid>
            </Grid>
            <Grid container item xs={1} justifyContent="flex-end">
              <Button
                variant="outlined"
                onClick={() => {
                  const newBookingSlots = values.possibleBookingSlots;
                  if (index > -1) {
                    newBookingSlots.splice(index, 1);
                  }
                  setFieldValue('possibleBookingSlots', newBookingSlots);
                }}
                disabled={values.possibleBookingSlots.length - 1 === 0}
              >
                <Remove />
              </Button>
            </Grid>
            {index !== values.possibleBookingSlots.length - 1 && (
              <Grid item xs={12} paddingTop={'1em'}>
                <Divider />
              </Grid>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};
